import { useEffect, useState } from 'react';

export const useAlertHook = () => {
  const [openAlert, setOpenAlert] = useState(false);
  const [title, setTitle] = useState('');
  const [text, setText] = useState('');
  const [submitText, setSubmitText] = useState('');
  const [submitCallback, setSubmitCallback] = useState(null);

  const showAlert = ({
    title: newTitle,
    text: newText,
    onSubmit: newSubmitCallback,
    submitText: newSubmitText,
  }) => {
    setOpenAlert(true);
    setTitle(typeof newTitle === 'string' ? newTitle : '');
    setSubmitCallback(() =>
      newSubmitCallback?.call ? newSubmitCallback : null,
    );
    setSubmitText(typeof newSubmitText === 'string' ? newSubmitText : '');
    setText(typeof newText === 'string' ? newText : '');
  };

  const closeAlert = () => {
    setOpenAlert(false);
  };

  const onSubmit = () => {
    if (submitCallback.call) {
      submitCallback();
      closeAlert();
    }
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (!openAlert) {
        setTitle('');
        setSubmitCallback(null);
        setSubmitText('');
      }
    }, 300);

    return clearTimeout(timeout);
  }, [openAlert]);

  return {
    title,
    openAlert,
    submitText,
    text,
    showAlert,
    closeAlert,
    onSubmit,
  };
};
